module.exports = __webpack_public_path__ + "img/friend-spam.ee881d31.png";